<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="`${this.$store.state.darkMode ? 'bg-transparent' : 'bg-success'}`"
  />
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="`${
      this.$store.state.isRTL
        ? 'me-3 rotate-caret fixed-end'
        : 'fixed-start ms-3'
    }
    ${
      this.$store.state.layout === 'landing'
        ? 'bg-transparent shadow-none'
        : ' '
    } ${this.$store.state.sidebarType}`"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link class="m-0 navbar-brand text-center" to="/">
        <img
          :src="
            this.$store.state.darkMode ||
            this.$store.state.sidebarType === 'bg-default'
              ? logoWhite
              : logo
          "
          class="navbar-brand-img h-100"
          alt="main_logo"
        />
        <img v-if="companyLogo" class="navbar-brand-img h-100" :src="companyLogo">
        <span class="ms-2 font-weight-bold me-2"></span>
      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo.png";
import logoWhite from "@/assets/img/logo.png";
import { useCompanyConfig } from '@/composables/useCompanyConfig';
export default {
  name: "index",
  components: {
    SidenavList
  },
  setup(){
        const { companyConfig,isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        // Cargar la configuración cada vez que el componente se monte/cargue
        fetchCompanyConfig();
        return { companyConfig ,isLoadingCiaConfig};
  },
  data() {
    return {
      logo,
      logoWhite,
      companyLogo:''
    };
  },
  watch:{
    companyConfig(newVal){
      this.companyLogo=newVal.logo_url;
    },
  },
  props: ["custom_class", "layout"]
};
</script>
